import React, { useState } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Loader } from "@revvsales/components";
import DocumentReviewClauseTag from "./DocumentReviewClauseTag";
import { getDocAnalysis } from "../../../../actions/MetalensActions/metalensActions";

const DocumentReviewSpotlights = ({
  active,
  goBack,
  clauseType,
  spotlightIndex,
  fullAnalysis,
  sharingHash,
  docID,
  isLatestAnalysis,
  getDocAnalysisAction,
}) => {
  const [activeAnalysisIndex, setActiveAnalysisIndex] = useState(0);
  const [reAnalyseLoader, setReAnalyseLoader] = useState(false);

  return (
    <div
      className={`documentreviewclauses animated fadeinright ${
        active ? "" : "documentreviewsection-inactive"
      }`}>
      <div className="documentreviewclauses-head">
        <div>
          <span
            onClick={goBack}
            role="button"
            onKeyDown={() => {}}
            tabIndex="0"
            className="documentreviewclauses-head-back-icon">
            <FontAwesomeIcon icon={["far", "angle-left"]} className="" />
          </span>
          <span>{clauseType.title}</span>
          {/* <span className="metalens-tags-head-total">
            {currentAnalysis.length}
          </span> */}
        </div>
      </div>
      <div className="documentreviewclauses-head-description">
        {clauseType.description}
      </div>
      {/* Reanalyse */}
      {!isLatestAnalysis && (
        <div className="metalens-detect-action documentreviewclauses-reanalyse">
          {reAnalyseLoader && (
            <Loader
              label="Re-analyzing this document"
              className="metalens-detect-loading"
              fullScreen={false}
            />
          )}
          <div className="metalens-detect-info">
            <span className="metalens-detect-info-icon">
              <FontAwesomeIcon icon={["far", "engine-warning"]} className="" />
            </span>{" "}
            Changes detected. Re-analysing the doc might lose your
            customisation.
          </div>
          <Button
            data-test="documentreviewlisting-btn-reanalyze"
            className="metalens-btn-add-tag metalens-detect-action-btn"
            onClick={() => {
              setReAnalyseLoader(true);
              getDocAnalysisAction(docID, sharingHash)
                .then(() => {
                  setReAnalyseLoader(false);
                })
                .catch(() => {
                  setReAnalyseLoader(false);
                });
            }}
            id="metalens-action-add">
            <FontAwesomeIcon icon={["far", "sync-alt"]} className="" />
            &nbsp; Re-Analyze this doc
          </Button>
        </div>
      )}
      <div
        className={`documentreviewclauses-body ${
          isLatestAnalysis ? "" : "documentreviewclauses-body-fit"
        }`}>
        {spotlightIndex &&
          spotlightIndex.map((si, index) => (
            <DocumentReviewClauseTag
              setActive={setActiveAnalysisIndex}
              docID={docID}
              sharingHash={sharingHash}
              index={index}
              active={activeAnalysisIndex === index}
              reviewClausesActive={active}
              analysis={fullAnalysis[si]}
              key={`${fullAnalysis[si].id}-document-spotlight`}
            />
          ))}
      </div>
    </div>
  );
};

const mapStateToProps = ({
  MetalensStore: { spotlightIndex, fullAnalysis, isLatestAnalysis },
  DocumentStore: { document: { id: docID } = {} } = {},
}) => ({
  spotlightIndex,
  docID,
  fullAnalysis,
  isLatestAnalysis,
});

const mapDispatchToProps = {
  getDocAnalysisAction: getDocAnalysis,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentReviewSpotlights);



// WEBPACK FOOTER //
// ./src/components/QuickReview/DocumentReviewSection/DocumentReviewClauses/DocumentReviewSpotlights.js